import type { ReactElement } from "react";

export function AuthLayout(page: ReactElement) {
	return <div className="p-3 bg-secondary h-screen">{page}</div>;
}
